// Implementation of the invoke method (http://underscorejs.org/#invoke) with support for
// lodash v3, v4, and underscore.js
import _ from 'underscore';

export default _.invokeMap || _.invoke;
